import { AccommodationInfo } from '../utils/accommodation';
import './AccommodationCard.css';

interface AccommodationCardProps {
  accommodation: AccommodationInfo;
  isSelected: boolean;
  onClick: () => void;
}

export default function AccommodationCard({
  accommodation,
  isSelected,
  onClick,
}: AccommodationCardProps) {
  return (
    <div
      className={`accommodation-card ${isSelected ? 'selected' : ''}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <div className="accommodation-icon">🏨</div>
      <div className="accommodation-content">
        <div className="accommodation-header">
          <h3 className="accommodation-name">{accommodation.name}</h3>
          {accommodation.nights > 0 && (
            <span className="accommodation-nights">
              {accommodation.nights} {accommodation.nights === 1 ? 'night' : 'nights'}
            </span>
          )}
        </div>
        {accommodation.address && (
          <div className="accommodation-address">{accommodation.address}</div>
        )}
      </div>
    </div>
  );
}

